<template>
  <div
    id="pagecoupons"
    :class="{
      'mx-0 mt-1': $vuetify.breakpoint.xs,
      'mx-3 mt-1': $vuetify.breakpoint.smAndUp,
    }"
  >
    <v-card>
      <customerBanner :customer="customer" />
      <v-layout row wrap class="ma-0" v-if="!pageLoading">
        <v-flex xs12 sm6 pt-3>
          <addBtn
            :text="lang.add_coupon"
            :disabled="pageLoading"
            @click="adding = true"
          ></addBtn>
          <v-btn
            :block="$vuetify.breakpoint.xs"
            color="primary"
            text
            @click="sendAllInvoices"
            :disabled="pageLoading || selectedItems.length == 0"
          >
            <v-icon left class="fal fa-paper-plane" small></v-icon>
            {{ lang.send_invoice }} ({{ selectedItems.length }})
            {{ selectedItemsPrice }}
          </v-btn>
          <v-btn
            :block="$vuetify.breakpoint.xs"
            color="secondary"
            text
            @click="export_all"
            :disabled="pageLoading"
          >
            <v-icon left class="fal fa-file-csv" small></v-icon>
            {{ lang.export_all }}
          </v-btn>
          <v-btn
            :block="$vuetify.breakpoint.xs"
            color="secondary"
            text
            @click="refresh"
            :disabled="pageLoading"
          >
            <v-icon left class="fa-light fa-arrows-rotate" small></v-icon>
            {{ lang.refresh }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 px-4 pb-3>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-skeleton-loader v-if="pageLoading" type="table"></v-skeleton-loader>
      <v-data-table
        v-else
        :headers="headers"
        :items="list"
        :search="search"
        item-key="id"
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td align="center">
              <v-checkbox
                :disabled="
                  (disableSelection && props.item.selected !== true) ||
                    canSelectCoupon(props.item)
                "
                v-model="props.item.selected"
                @click="updateSelectedItems"
              ></v-checkbox>
            </td>
            <td align="center">
              <v-btn
                text
                class="primary--text no-uppercase"
                v-clipboard:copy="props.item.id"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                >{{ props.item.id }}</v-btn
              >
            </td>
            <td align="center">
              {{ props.item.name }}
              <span v-if="props.item.metadata.note"
                >({{ props.item.metadata.note }})</span
              >
            </td>
            <td align="center">
              {{ props.item.created | moment("DD, MMMM YYYY") }}
            </td>
            <td align="center">
              {{ getPlanName(props.item.metadata.plan) }} /
              {{ props.item.metadata.qty || 0 }}
            </td>
            <td align="center">{{ props.item.metadata.used_by || "" }}</td>
            <td align="center">
              {{
                getOffValue(
                  props.item.currency,
                  props.item.amount_off,
                  props.item.percent_off,
                  props.item.duration
                )
              }}
            </td>
            <!--<td align="center">{{ props.item.times_redeemed}}/{{props.item.max_redemptions}}</td>-->
            <td align="center">
              <v-tooltip top v-if="props.item.metadata.status == 'paused'">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-bind="attrs"
                    v-on="on"
                    small
                    color="error"
                    text-color="white"
                    >{{ lang.paused }}</v-chip
                  >
                </template>
                <span
                  >{{ lang.paused }} by {{ props.item.metadata.paused_by }} @
                  {{
                    new Date(props.item.metadata.paused_at).toDateString()
                  }}</span
                >
              </v-tooltip>
              <v-chip
                v-if="props.item.metadata.free == 'true'"
                small
                color="primary"
                text-color="white"
                >{{ lang.free }}</v-chip
              >
              <v-chip
                v-else-if="props.item.valid"
                small
                color="cyan"
                text-color="white"
                >{{ lang.valid }}</v-chip
              >

              <v-chip
                v-else-if="props.item.metadata.paid == 'true'"
                small
                color="green"
                text-color="white"
                >{{ lang.paid }}</v-chip
              >
              <v-tooltip
                top
                v-if="
                  props.item.metadata.invoice_url &&
                    props.item.metadata.free != 'true'
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="openInvoice(props.item.metadata.invoice_url)"
                    small
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                    icon
                    color="primary"
                  >
                    <v-icon small class="fal fa-file-invoice-dollar"></v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.open_invoice }}</span>
              </v-tooltip>
              <v-chip
                v-else-if="props.item.metadata.invoiced == 'true'"
                small
                color="orange"
                text-color="white"
                >{{ lang.invoiced }}</v-chip
              >
              <!-- <v-chip
                v-else-if="!props.item.valid"
                small
                color="deep-orange"
                text-color="white"
              >{{ lang.used}}</v-chip> -->
              <v-tooltip top v-else-if="canSendInvoice(props.item)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="sendInvoice(props.item.id)"
                    small
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                    icon
                    color="primary"
                  >
                    <v-icon small class="fal fa-paper-plane"></v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.send_invoice }}</span>
              </v-tooltip>
            </td>
            <td align="center">
              <v-btn
                :disabled="!props.item.valid"
                text
                icon
                @click="
                  {
                    {
                      openDialog(props.item.id);
                    }
                  }
                "
                color="primary"
              >
                <v-icon small class="fa-light fa-xmark red--text"></v-icon>
              </v-btn>
              <v-tooltip top v-if="props.item.metadata.status == 'paused'">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="props.item.valid"
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click="
                      {
                        {
                          unpause(props.item.id);
                        }
                      }
                    "
                    color="primary"
                  >
                    <v-icon small class="fa-light fa-play green--text"></v-icon>
                  </v-btn>
                </template>
                {{ lang.activate_sub }}
              </v-tooltip>
              <v-tooltip top v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :disabled="props.item.valid"
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click="
                      {
                        {
                          openPauseDialog(props.item.id);
                        }
                      }
                    "
                    color="primary"
                  >
                    <v-icon
                      small
                      class="fa-light fa-pause orange--text"
                    ></v-icon>
                  </v-btn>
                </template>
                {{ lang.pause_sub }}
              </v-tooltip>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
      <dialogConfirm
        :dialog="deleteConfirm"
        :title="lang.deleteConfirm"
        :msg="lang.deleteMsg"
        @onConfirm="deleteCoupon()"
        @onCancel="cancelDelete()"
      />
      <dialogConfirm
        :dialog="pauseConfirm"
        :title="lang.pause_sub"
        :msg="lang.pauseMsg"
        @onConfirm="pause()"
        @onCancel="cancelPause()"
      />
      <addCouponElm @close="adding = false" :dialog="adding" :plans="plans" />
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
const coupons = require("./coupons.js").coupons;
import customerBanner from "./customer";
import addCouponElm from "./add_coupon";
import dialogConfirm from "@/components/dialogConfirm";
import addBtn from "@/components/addBtn";
export default {
  data() {
    return {
      disableSelection: false,
      selectedItems: [],
      selectedItemsPrice: "",
      headers: [],
      plans: [],
      list: [],
      customer: {},
      search: "",
      pageLoading: true,
      deleteConfirm: false,
      pauseConfirm: false,
      adding: false,
    };
  },
  components: {
    customerBanner,
    dialogConfirm,
    addCouponElm,
    addBtn,
  },
  computed: {
    ...mapState(["lang", "breadcrumb", "adminUser", "fb"]),
  },
  async mounted() {
    this.headers = [
      { text: "", value: "", align: "center" },
      { text: this.lang.coupon_id, value: "id", align: "center" },
      { text: this.lang.name, value: "name", align: "center" },
      { text: this.lang.created, value: "created", align: "center" },
      {
        text: this.lang.plan + " / " + this.lang.num_displays,
        value: "plan",
        align: "center",
      },
      { text: this.lang.used_by, value: "used_by", align: "center" },
      { text: this.lang.amount_off, value: "amount_off", align: "center" },
      /* {
        text: this.lang.redemptions + "/" + this.lang.max_redemptions,
        value: "times_redeemed",
        align: "center"
      },*/
      { text: this.lang.status, value: "valid", align: "center" },
      { text: "", value: "delete", align: "center" },
    ];
    var breadcrumb = {};
    breadcrumb.title = this.lang.coupons;
    var me = this;

    breadcrumb.items = [
      {
        title: this.lang.dashboard,
        action: function() {
          me.$router.push({ path: "/dashboard" });
        },
      },
    ];
    this.$store.commit("breadcrumb", breadcrumb);
    coupons.init(this);
    await this.adminUser.updateBrand();
    this.$bind(
      "list",
      this.fb.db
        .collection(`brands/${this.adminUser.brand_id}/coupons`)
        .orderBy("created", "desc")
    );
  },
  methods: {
    deSelectItems() {
      this.list.forEach((item) => (item.selected = false));
      this.selectedItems = [];
      this.selectedItemsPrice = "";
      this.disableSelection = false;
    },
    updateSelectedItems() {
      this.selectedItems = this.list.filter((item) => item.selected === true);
      this.selectedItemsPrice = "";
      let amount = 0;
      let currency = "";
      this.selectedItems.forEach((item) => {
        amount += item.amount_off;
        currency = item.currency;
      });
      if (this.selectedItems.length > 0)
        this.selectedItemsPrice =
          this.getCurrency(currency) + " " + amount / 100; //+ " " + duration;
      if (this.selectedItems.length >= 20) {
        this.disableSelection = true;
      } else {
        this.disableSelection = false;
      }
    },
    canSelectCoupon(item) {
      return !this.canSendInvoice(item);
    },
    canSendInvoice(item) {
      return (
        !item.valid &&
        item.metadata.can_send_invoice == "true" &&
        !item.metadata.invoice_id &&
        item.metadata.free != "true"
      );
    },
    pause() {
      //this.pageLoading = true;
      coupons.pause(this.currentCouponId);
      this.currentCouponId = "";
      this.pauseConfirm = false;
    },
    unpause(id) {
      //this.pageLoading = true;
      coupons.unpause(id);
      this.currentCouponId = "";
      this.pauseConfirm = false;
    },
    cancelPause() {
      this.currentCouponId = "";
      this.pauseConfirm = false;
    },
    getPlanName(plan) {
      for (var i = 0; i < this.plans.length; i++) {
        if (plan == this.plans[i].id) {
          return this.plans[i].nickname;
        }
      }
      return "";
    },
    getCurrency(currency) {
      switch (currency) {
        case "usd":
          return this.lang.dollars;
        case "aud":
          return this.lang.au_dollars;
      }
      return currency;
    },
    openPauseDialog(id) {
      this.pauseConfirm = true;
      this.currentCouponId = id;
    },
    openDialog(id) {
      this.deleteConfirm = true;
      this.currentCouponId = id;
    },
    openInvoice(url) {
      window.open(url, "_blank");
    },
    sendInvoice(coupon) {
      coupons.sendInvoice(coupon);
    },
    sendAllInvoices() {
      const coupon = this.selectedItems.map((item) => item.id);
      coupons.sendInvoice([...new Set(coupon)]); //send unique array
      this.deSelectItems();
    },
    deleteCoupon() {
      this.pageLoading = true;
      coupons.del(this.currentCouponId);
      this.currentCouponId = "";
      this.deleteConfirm = false;
    },
    cancelDelete() {
      this.currentCouponId = "";
      this.deleteConfirm = false;
    },
    refresh() {
      this.pageLoading = true;
      this.deSelectItems();
      coupons.init(this);
    },
    export_all() {
      //list
      console.log(this.list);
      let csvContent = "";
      csvContent =
        "Coupon,Name,Qty,Amount,Invoice ID,Plan,Note,Used By,Used\r\n";
      this.list.forEach(function(cp) {
        csvContent += `${cp.id},'${cp.name}',${cp.metadata.qty ||
          "N/A"},${cp.amount_off || "N/A"},${cp.metadata.invoice_id ||
          "N/A"},${cp.metadata.plan || "N/A"},${cp.metadata.note || "N/A"},${cp
          .metadata.used_by || "N/A"},${cp.valid}\r\n`;
      });
      var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute(
          "download",
          `licences_${new Date().toISOString()}.csv`
        );
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    getOffValue(currency, amount, percentage, duration) {
      if (currency != "") {
        return this.getCurrency(currency) + " " + amount / 100; //+ " " + duration;
      } else {
        return percentage + "% " + duration;
      }
    },

    copyToClipboard(text) {
      var input = text;
      input.select();
      document.execCommand("copy");
    },

    onCopy() {
      this.$toastr("success", this.lang.copied);
    },
    onError() {
      this.$toastr("error", this.lang.error);
    },
  },
};
</script>
<style>
.no-uppercase {
  text-transform: none;
}
</style>
